"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.RangeForm = void 0;
var comment_box_form_1 = require("../comment-box-form");
var RangeForm = /** @class */ (function (_super) {
    __extends(RangeForm, _super);
    function RangeForm(msg) {
        var _this = _super.call(this) || this;
        _this.keysOrder = ['Definition', 'Reasons for High', 'Reasons for Low', 'Reasons for Base', 'Others'];
        _this.form = {
            'Definition': { comment: '', gridType: 'long' },
            'Reasons for High': { comment: '', gridType: 'long' },
            'Reasons for Low': { comment: '', gridType: 'long' },
            'Reasons for Base': { comment: '', gridType: 'long' },
            'Others': { comment: '', gridType: 'long' }
        };
        _this.parseFormComments(msg);
        return _this;
    }
    return RangeForm;
}(comment_box_form_1.CommentBoxForm));
exports.RangeForm = RangeForm;
//# sourceMappingURL=range-form.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/comment-box/range-form/range-form.js